import {Stack, StackProps} from "@chakra-ui/react";
import {JSX} from "react";
import {ProductIcon} from "../../atoms/SvgImage";
import * as React from "react";

export interface CardIconProps extends StackProps {
    icon?: JSX.Element;
}

export const CardIcon = ({icon, ...props}: CardIconProps) => {
    return <Stack
        w={"70px"}
        h={"70px"}
        minW={"70px"}
        alignItems={"center"}
        justifyContent={"center"}
        rounded={"50%"}
        backgroundColor={"rgba(255,255,255,0.16)"}
        {...props}>
        {icon || <ProductIcon strokeColor={"white"}/>}
    </Stack>
}
